var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCityscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cityscape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "M11.427 17l-1.5 3h27.146l-1.5-3H11.427zM9 28.5V23H7.5a1.5 1.5 0 0 1-1.342-2.17l3-6A1.5 1.5 0 0 1 10.5 14h26a1.5 1.5 0 0 1 1.342.83l3 6A1.5 1.5 0 0 1 39.5 23H38v31.5a1.5 1.5 0 0 1-3 0V23H12v5.737a8.522 8.522 0 0 0-2-.237H9zm8.955 5.5H20.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-.978a8.502 8.502 0 0 0-1.023-.876L18.5 37a8.481 8.481 0 0 0-.545-3zM17 51.748a8.527 8.527 0 0 0 3-2.27V54.5a1.5 1.5 0 0 1-3 0v-2.752zm5-7.652c.47-.064.971-.096 1.5-.096 4.097 0 6.5 1.922 6.5 5.5v5a1.5 1.5 0 0 1-3 0v-5c0-1.755-.93-2.5-3.5-2.5-.921 0-1.632.096-2.164.3a8.47 8.47 0 0 0 .663-3.204zM17.5 26h3a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-1a1.5 1.5 0 0 1 1.5-1.5zm9 0h3a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-1a1.5 1.5 0 0 1 1.5-1.5zm0 8h3a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-1a1.5 1.5 0 0 1 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "M29 4.893V9.5a1.5 1.5 0 0 1-3 0v-6a1.5 1.5 0 0 1 1.39-1.496l27-2A1.5 1.5 0 0 1 56 1.5v53a1.5 1.5 0 0 1-3 0V3.115L29 4.893zM7.035 37.463a1.5 1.5 0 0 1-1.088 1.677A4.002 4.002 0 0 0 7 47c.923 0 1.793-.311 2.498-.876a1.5 1.5 0 0 1 1.96.073 3 3 0 1 0 2.203-5.193 1.5 1.5 0 0 1-1.168-2.334 3 3 0 1 0-5.458-1.206zM12 49.811V54.5a1.5 1.5 0 0 1-3 0v-4.79a7 7 0 0 1-4.991-13.04 6 6 0 1 1 11.81 1.795A6 6 0 1 1 12 49.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    d: "M43.5 11a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3h-5zm-10 0a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3h-5zm10 8a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3h-5zm0 8a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3h-5zm0 8a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3h-5zm0 8a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3h-5zm0 8a1.5 1.5 0 0 1 0-3h5a1.5 1.5 0 0 1 0 3h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityscape);
export default __webpack_public_path__ + "static/media/Cityscape.43572a65d9416f5a1187e9c2aac59838.svg";
export { ForwardRef as ReactComponent };